import { useQuery } from "@design-lab/shared/graphql";
import { ShopifyStoresDocument } from "graphql-api/operations";

/**
 * Hook for fetching active Shopify stores.
 *
 * @returns Object containing:
 *   - stores: Array of active Shopify stores
 *   - isLoading: Whether the query is in progress
 *   - error: Error if the query failed
 */
export function useShopifyStores() {
  const { data, loading, error } = useQuery(ShopifyStoresDocument);

  return {
    stores: data?.shopifyStores ?? [],
    isLoading: loading,
    error
  };
}
